const Home = props => {
    return (
        <>
            <h1>Welcome to 'React hooks use cases'</h1>
            <p>ℹ️ This is a list of React hooks use cases that I'm building during my ReactJS studies. I've built it because I wanted a very specific and targeted way of practising my hook knowledge.</p>
            <p>🎨 Design and graphics are being used very sparingly un purpose to keep the code clean and easy to follow.</p>
            <p>📝 The source code of this project can be found on my <a href="https://github.com/Colo-Codes/react-hooks-use-cases" target="_blank" rel="noreferrer">GitHub repository</a>.</p>
            <p>👨‍💻 This project was made by <a href="https://www.damiandemasi.com" target="_blank" rel="noreferrer">Damian Demasi</a></p>
        </>
    );
};

export default Home;